module.exports = __webpack_public_path__ + "static/banner-moc-2-1-72573c4b3d304a91e6d68bf3a857009e.png";